<template>
	<div class="ab-page">
		<div class="ab-linkage">

			<div class="ab-value-wrapper">
				<v-select class="small"
									v-model="page.ab_geo"
				          :options="countries"
				          v-if="step.ab_type==='geo'" @input="geoChange"
				          label="text"
				          :reduce="x=>x.id"
				          :searchable="true"
				          :clearable="false"
				          placeholder="ALL"
				          append-to-body>
					<template #selected-option="{ id }">
						<i v-if="!id || id==='all'"><b style="color: grey">ALL</b></i>
						<b v-else>{{id}}</b>
					</template>
					<template #option="o">
						<b v-if="o.id==='all'">{{o.text}}</b>
						<span v-else>{{o.text}}</span>
					</template>
				</v-select>

				<select v-else @change="abChange" v-model="page.ab_percent">
					<option v-for="i in [0, 10,20,30,40,50,60,70,80,90,100]" :value="i">
						{{i}} %
					</option>
				</select>
				<v-spinner v-if="saving" />
			</div>

		</div>

		<div class="img">
			<img :src="page ? page.thumbnail_hash : ''" alt=""
			     @load="imageLoading=false">
			<v-spinner v-if="imageLoading" />
		</div>
		<div class="name">
<!--			<input-field v-model="page.name" flat small is-save />-->
	    <h3 >
		    <span :ref="'page_entry_name_'+id" contenteditable="true" @focus="nameEditing=true" @blur="nameBlur" @input="updateName">{{ page.name }}</span>
		    <v-button v-if="nameEditing || !saved" flat  class="save-btn" v-tippy="{theme:'small-black'}" content="Save changes"
		              :icon="require('@/assets/page/img/save_dismiss_circle_btns_save.svg')" :loading="saving"
		              @click="saveName">
		    </v-button>
	    </h3>

		</div>
		<div class="btns">

			<v-button slim border
			          :icon="require('@/assets/img/pencil_edit_icon.svg')"
			          :href="editPageUrl" label="Edit page variant">
			</v-button>

			<v-button small v-tippy="{theme:'small-black'}" content="Preview" :href="pagePreviewUrl"
			          :icon="require('@/assets/icons/preview.svg')"
			          flat target="_blank">
			</v-button>

			<div class="__sep"></div>

			<quick-actions-btn @itemClick="itemClick" :loading="cloning" content="More actions"
			                   :items="[{label:'Duplicate page variant',icon:require('@/assets/img/copy.svg')},
			                   {label:'Revisions...',icon:require('@/assets/img/history.svg')},
			                   '',
			                   {label:'Delete page variant',icon:require('@/assets/img/trash.svg')}]" />
		</div>
		<delete-page-popup v-if="isDeletePageOpen"
		                   :name="page.name" :funnel-id="page.funnel_id" :step-id="page.step_id"
		                   :page-id="page.id" @close="isDeletePageOpen=false" @deleted="removePage" />

		<popup-backdrop v-if="revisionsPopupOpen" @close="revisionsPopupOpen=false">
			<page-revisions-popup :page="page" :step="step"
			               @done="revisionsPopupOpen=false" @close="revisionsPopupOpen=false" />
		</popup-backdrop>

	</div>
</template>

<script>
import VSpinner from "@/components/base/v-spinner";
import InputField from "@/components/base/input-field";
import VButton from "@/components/base/v-button";
import DeletePagePopup from "@/views/funnels/funnel-plus/steps/delete-page-popup";
import API from "@/api";
import countries from "@/helpers/countries";
import QuickActionsBtn from "@/components/base/quick-actions-btn";
import PopupBackdrop from "@/components/base/popup-backdrop";
import PageRevisionsPopup from "@/views/funnels/funnel-plus/steps/page-revisions-popup";

let id = 0;

export default {
name: "step-page-entry",
	components: {PageRevisionsPopup, PopupBackdrop, QuickActionsBtn, DeletePagePopup, VButton, InputField, VSpinner},
	mixins: [API],
	props:['page', 'step', 'abCallback'],
	data(){
		return {
			revisionsPopupOpen:false,
			countries: [{id:'all',text:'All the rest'}, ...countries],
			id: id++,
			saved: true,
			saving: false,
			nameEditing: false,
			cloning: false,
			imageLoading: true,
			isDeletePageOpen: false,

		}
	},
	computed:{
		pagePreviewUrl() {
			return `https://${this.page.url}?preview=${this.page.id}`;
		},
		editPageUrl(){
			// /wfunnel/:funnel/steps/:step/pages/:page/:token/:user
			return `/page-editor/wfunnel/${this.page.funnel_id}/steps/${this.page.step_id}/pages/${this.page.id}/${this.$store.state.userInfo.id}`
		},
	},
	methods:{
		itemClick(ev) {
			if (ev.action==='Duplicate page variant') {
				this.clonePage()
			} else if (ev.action==='Delete page variant') {
				this.isDeletePageOpen=true;
			} else if (ev.action==='Revisions...') {
				this.revisionsPopupOpen = true;
			}
		},
		async abChange(ev){
			let v = ev.target.value;
			this.page.ab_percent = parseInt(v);
			await this.saveProps();

			// TODO: update other entries.

		},
		async geoChange(ev){
			this.page.ab_geo = ev;
			await this.saveProps();
		},
		async saveProps() {
			try {
				this.saving = true
				let result = await this.api.wsteps.savePageProps(this.page.funnel_id, this.step.id, this.page.id, {
					name: this.page.name,
					ab_percent: this.page.ab_percent,
					ab_type: this.step.ab_type,
					ab_geo: this.page.ab_geo,
				});
				if (result.error) throw result;
				this.saved = true;
			} catch (e) {
				this.$warn(e);
			} finally {
				this.saving = false
			}
		},
		nameBlur(){
			this.nameEditing = false;
		},
		removePage() {
			let index = this.step.pages.indexOf(this.page);
			if (index>=0) this.step.pages.splice(index, 1);
		},
		updateName(ev){
			// don't update page name here, it causes focus to switch.
			// this.page.name = ev.target.innerText;
			this.saved=false
		},
		async saveName(ev) {
			this.page.name = this.$refs['page_entry_name_'+this.id].innerText;
			await this.saveProps();
		},
		async clonePage() {
			try {
				this.cloning = true

				let result = await this.api.wsteps.clonePage(this.page.funnel_id, this.step.id, this.page.id);
				if (!result.error) {
					this.step.pages.push(result);
				}
			} catch (e) {
				this.$warn(e);
			} finally {
				this.cloning = false
			}
		},
	}
}
</script>

<style lang="scss" scoped>
.ab-page {
	.btns {
		flex: none;
		display: flex;
		flex-direction: row;
		align-items: center;
		gap: 15px;
		margin: 0 15px;
		.__sep {
			background: $grey;
			width: 1px;
			height: 24px;
			//margin: 1px 5px;
		}
	}
	.ab-linkage {
		select {
			background: white;
			border: 1px solid $light-grey; // border causes unwanted shift.
			border-radius: 10px;
			width: 100%;
			height: 100%;
			position: absolute;
			padding: 0 10px;

			&::-ms-expand {
				display: none;
			}

			&:hover {
				border: 1px solid $blue;
			}
		}
	}
}
</style>
<style lang="scss" >
.ab-page {
	.img {
		position: relative;
	}
	.ab-value-wrapper {
		position: relative;
		background: white;
		box-shadow: 0 0 2px #e4e6f1;
		border-radius: 10px;
		top: 12px;
		height: 22px;
		left: 20px;
		padding: 0;
		max-width: 70px;
		.v-select {
			font-size: 12px;
		}
		.vs__dropdown-toggle {
			height: 24px;
			background: white;
			border-radius: 15px;
			border: 1px solid #E4E6F1;; // border causes unwanted shift.
			.vs__selected-options {
				padding: 0 2px;
			}
			.vs__search, .vs__search:focus {
				margin: 0 !important;
			}
			.vs__selected {
				justify-content: center;
			}
		}
	}
	.name {
		margin-right: 20px;
		h3 {
			position: relative;
			width: fit-content;
			padding: 2px 5px;
			word-break: break-all;
			margin-right: 20px;
		}
	}
	.save-btn {
		position: absolute;
		width: 26px;
		height: 26px;
		right: -26px;
		top: 0;
		padding: 4px;
		border-radius: 20px;
		border: 1px solid $light-grey;
		box-shadow: 0 1px 3px rgba(0, 0, 0, 0.15);
		svg {
			margin: auto !important;
		}
	}

}
</style>
